<template>
    <div>
        <div class="cons">
            <div class="actips flx jsb">
                <div class="tipLeft">
                    <div class="compart">
                        <div class="comTop flx">
                            <div class="comImg">
                                <img :src="$img(info.shop_avatar)" alt="" />
                            </div>
                            <div class="cominfo">
                                <div class="flx jsb">
                                    <div class="flx alc">
                                        <div class="comTitle" v-text="info.shop_name"></div>
                                        <img :src="$Localimg('confirm.png')" alt="" style="position: relative;top: -5px;" />
                                    </div>
                                    <div class="acfocus cursor" v-if="info.shop_follow_status == 1" @click.stop="focusThis">
                                        已关注
                                    </div>
                                    <div class="unfocus cursor" v-else @click.stop="focusThis">
                                        关注
                                    </div>
                                </div>
                                <div class="flx" style="justify-content: flex-start;">
                                    <div class="label" v-text="info.shop_label">
                                        
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    
                    
                    <div class="companyDetail">
                        <div class="comCates flx alc">
                            <div class="cateItem" @click="changeTab(0)">
                                <div class="cateName" :class="cur == 0?'active':''">
                                    简介
                                </div>
                                <div class="linearheng" v-if="cur == 0"></div>
                            </div>
                            
                            <div class="cateItem" @click="changeTab(1)">
                                <div class="cateName" :class="cur == 1?'active':''">
                                    活动
                                </div>
                                <div class="linearheng" v-if="cur == 1"></div>
                            </div>
                            
                            <div class="cateItem" @click="changeTab(2)">
                                <div class="cateName" :class="cur == 2?'active':''">
                                    招聘
                                </div>
                                <div class="linearheng" v-if="cur == 2"></div>
                            </div>
                        </div>
                        
                        <div class="companyDetais"> 
                          <!-- 企业简介 -->
                            <div class="comIntro" v-if="cur == 0">
                                <div class="cimg" v-for="item,index in images" v-if="images.length > 0">
                                    <img :src="$img(item)" alt="" />
                                </div>
                            </div>
                            <!-- 企业活动 -->
                            <div class="activities flx" v-if="cur == 1">
                                <div class="reItem" @click="toDetail(item)" v-for="item,index in aclist" :style="(index + 1) % 3 == 0?'margin-right:0' : ''">
                                    <div class="labelName" v-text="item.label" v-if="item.label">
                                        
                                    </div>
                                    <div class="reImg">
                                        <img :src="$img(item.pc_avatar)" alt="" />
                                    </div>
                                    <div class="reInfo">
                                        <div class="reName multy2" v-text="item.name">
                                
                                        </div>
                                        <div class="reTitle single" v-text="item.title">
                                
                                        </div>
                                        <div class="flx" style="justify-content: flex-end;margin-top: 20px;">
                                            <div class="rebtn">
                                                马上查看
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- 企业招聘 -->
                            
                            <div class="comRe" v-if="cur == 2">
                                <div class="recItem flx alc jsb" v-for="item,index in zlist">
                                    <div class="recLeft">
                                        <div class="recNames flx alc">
                                            <div class="recName" v-text="item.name"></div>
                                            <div class="recPrice" v-text="`${item.salary_mix} - ${item.salary_max}`"></div>
                                        </div>
                                        <div class="labels flx" style="justify-content: flex-start;margin-bottom: 12px;">
                                            <div class="label" style="margin-right: 10px;" v-text="item.exp_name"></div>
                                            <div class="label" v-text="item.eb_name"></div>
                                        </div>
                                        <div class="recAddress flx alc">
                                            <i class="el-icon-location" style="font-size: 16px;color: #BDC3D4;margin-right: 3px;"></i>
                                            <div v-text="`${item.city_name}·${item.area_name}`"></div>
                                        </div>
                                    </div>
                                    <div class="recRight">
                                        投递简历
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="tipRight">
                    <asideAc></asideAc>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getActivitiesDetails,
        getActiviesList,
        focusCom,
        getRelist
    } from "@/api/index.js"
    import asideAc from "@/components/asidAc.vue"
    export default {
        components: {
            asideAc
        },
        data() {
            return {
                id: '',
                page: 1,
                info: {},
                cur:0,
                images:[],
                aclist:[],
                zlist:[],
                totals:0
            }
        },
        created() {
            this.id = this.$route.query.aid
            this.getDetail()
        },
        methods: {
            toDetail(e){
                let that = this 
                that.$router.push({
                    path: '/signDetail', // 写路由path
                    query: {
                        id: e.id
                    }
                })
            },
            changeTab(e){
                let that = this 
                if(e != 0){
                    that.page = 1
                    that.aclist = []
                    that.zlist = []
                }
                if(e == 1){
                    that.getAclist()
                }
                
                if(e == 2){
                    that.getzlist()
                }
                
                that.cur = e
            },
            getzlist(){
                let that = this 
                let data = {}
                data.company_id = that.$route.query.id
                getRelist(data).then((res) => {
                    console.log("z",res)
                    if(res.code == 1){
                        that.zlist = res.data.data
                    }
                })
            },
            getAclist(){
                let that = this
                let data = {}
                data.source = 'company'
                data.page = 1
                data.size = 20
                data.company_id = that.$route.query.id
                getActiviesList(data).then((res) => {
                    console.log(res)
                    if(res.code == 1){
                        that.aclist = res.data.list.data
                        that.totals = res.data.list.total
                    }
                })
            },
            focusThis() {
                let that = this
                let data = {}
                data.company_id = that.info.company_id
                focusCom(data).then((res) => {
                    if (res.code == 1) {
                        that.$message.success(res.msg)
                        that.getDetail()
                    } else {
                        that.$message.error(res.msg)
                    }
                })
            },
            getDetail() {
                let that = this
                let data = that.id
                getActivitiesDetails(data).then((res) => {
                    console.log("res", res)
                    if (res.code == 1) {
                        that.info = res.data
                        that.images = res.data.shop_content.split(',')
                        that.$nextTick(() => {
                            window.scrollTo(0, 0)
                        })
                    }
                })
            }
        }
    }
</script>

<style scoped>
    .recAddress{
        font-size: 14px;
        color: #555C70;
    }
    .recNames{
        margin-bottom: 12px;
    }
    .recName{
        font-weight: 600;
        font-size: 18px;
        color: #000000;
    }
    .recPrice{
        font-weight: 600;
        font-size: 18px;
        color: #007AFF;
        margin-left: 14px;
    }
    .recItem{
        width: 100%;
        height: 131px;
        background: #FDFDFD;
        border-radius: 10px;
        border: 1px solid #E0E0E0;
        margin-bottom: 20px;
        box-sizing: border-box;
        padding: 20px;
    }
    .recRight{
        width: 88px;
        height: 36px;
        background: #007AFF;
        border-radius: 3px;
        text-align: center;
        line-height: 36px;
        color: #fff;
        cursor: pointer;
        font-size: 14px;
    }
    .activities{
        flex-wrap: wrap;
    }
    .reImg {
        width: 344px;
        height: 194px;
    }
    
    .reImg img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
    
    .rebtn {
        width: 104px;
        height: 36px;
        background: linear-gradient(90deg, #4A9EFF 0%, #1E7FE5 100%);
        box-shadow: 0px 2px 6px 0px rgba(30, 127, 229, 0.25);
        border-radius: 18px;
        font-size: 14px;
        color: #FFFFFF;
        text-align: center;
        line-height: 36px;
    }
    
    .reTitle {
        font-weight: 500;
        font-size: 14px;
        color: #9CA3AF;
        margin-top: 10px;
    }
    
    .reInfo {
        box-sizing: border-box;
        padding: 20px;
        text-align: left;
    }
    
    .reName {
        height: 48px;
        line-height: 24px;
        width: 100%;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
    }
    
    .relist {
        flex-wrap: wrap;
        justify-content: space-between;
        box-sizing: border-box;
        padding-bottom: 56px;
    }
    
    .reItem {
        width: 334px;
        height: 372px;
        background: #FFFFFF;
        box-shadow: 0px 4px 7px 0px rgba(0, 0, 0, 0.08);
        border-radius: 12px;
        margin-bottom: 26px;
        overflow: hidden;
        position:relative;
        margin-right: 26px;
        cursor: pointer;
    }
    .companyDetais{
        margin-top: 20px;
    }
    .cimg{
        width: 100%;
    }
    .cimg img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .comIntro{
        width: 100%;
    }
    .active{
        font-weight: 600 !important;
        font-size: 16px !important;
        color: #222222 !important;
    }
    .comCates{
        
    }
    .cateName{
        position: relative;
        z-index: 3;
        font-size: 16px !important;
        color: #666666;
    }
    .cateItem{
        position: relative;
        margin-right: 30px;
        cursor: pointer;
    }
    .linearheng{
        width: 36px;
        height: 8px;
        background: linear-gradient( 90deg, #BAD9FF 0%, rgba(255,255,255,0) 100%);
        position: absolute;
        left: 0;
        bottom: 0;
    }
    .companyDetail{
        background: #fff;
        margin-top: 16px;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }
    .label{
        font-weight: 500;
        font-size: 13px;
        color: #3F8AE6;
        box-sizing: border-box;
        padding: 4px 10px;
        background: #F2F9FF;
        border-radius: 2px;
        display: inline-block;
    }
    .comDes {
        font-size: 14px;
        color: #6D6D6D;
        margin-top: 12px;
    }

    .acfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        border: 1px solid rgba(64, 150, 255, 1);
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        color: #007AFF;
        font-weight: 500;
    }

    .unfocus {
        width: 68px;
        height: 38px;
        border-radius: 19px;
        color: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 15px;
        background: #007AFF;
        font-weight: 500;
    }

    .cominfo {
        flex: 1;
    }

    .cominfo img {
        width: 20px;
        height: 20px;
        margin-left: 12px;
        text-align: left;
    }

    .comTitle {
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }

    .comImg {
        width: 60px;
        height: 60px;
        margin-right: 12px;
    }

    .comImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        margin-right: 12px;
        object-fit: cover;
    }

    .compart {
        width: 100%;
        background: #fff;
        border-radius: 6px;
        box-sizing: border-box;
        padding: 26px;

    }

    .bheng {
        width: 24px;
        height: 4px;
        background: #007AFF;
        margin: 0 auto;
        margin-top: 8px;
    }

    .actitles {
        display: inline-block;
        position: relative;
        margin-bottom: 20px;
    }

    .actName {
        font-weight: 500;
        font-size: 18px;
        color: #3C464F;

    }

    .acintro {
        background-color: #fff;
        margin-top: 16px;
        box-sizing: border-box;
        padding: 26px;
        text-align: left;
    }

    .tipLeft {
        width: 1106px;

    }

    .buytip {
        text-align: left;
        width: 100%;
        background: #fff;
        border-radius: 10px;
        box-sizing: border-box;
        padding: 26px;
    }

    .actips {
        margin-top: 16px;
    }

    .btns {
        margin-top: 26px;
        box-sizing: border-box;
        padding-left: 396px;
    }

    .btnRight i {
        margin-right: 6px;
    }

    .btnRight {
        width: 130px;
        height: 40px;
        border-radius: 8px;
        border: 1px solid rgba(64, 150, 255, 1);
        justify-content: center;
        font-weight: 600;
        font-size: 14px;
        color: #007AFF;
    }

    .btnLeft {
        width: 190px;
        height: 40px;
        background: linear-gradient(90deg, #4096FF 0%, #1677FF 100%);
        border-radius: 8px 8px 8px 8px;
        text-align: center;
        line-height: 40px;
        font-weight: 500;
        font-size: 14px;
        color: #FFFFFF;
        margin-right: 14px;
    }

    .freePart {
        width: 48px;
        height: 26px;
        background: #EFF6FF;
        border-radius: 13px;
        font-size: 12px;
        color: #1E40AF;
        text-align: center;
        line-height: 26px;
    }

    .acNames {
        margin-bottom: 22px;
    }

    .infItem span {
        font-size: 14px;
        color: #1F2937;
    }

    .infItem {
        margin-bottom: 16px;
    }

    .infItem img {
        width: 20px;
        height: 20px;
        margin-right: 12px;
    }

    .buyItem {
        font-size: 14px;
        margin-left: 18px;
    }

    .buyItem img {
        width: 20px;
        height: 20px;
    }

    .buyItem span {
        margin-left: 4px;
    }

    .acName {
        font-weight: 600;
        font-size: 18px;
    }

    .acInfo {
        flex: 1;
    }

    .acImg {
        width: 344px;
        height: 194px;
        margin-right: 20px;
    }

    .acImg img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        object-fit: cover;
    }

    .acTivitiesDetail {
        width: 100%;
        background: #fff;
        box-sizing: border-box;
        padding: 26px;
    }

    .cons {
        width: 1460px;
        margin: 0 auto;
        box-sizing: border-box;
        padding: 20px 0;
        border-radius: 10px;
    }
</style>